var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"UserNotificationsIcon"},[_c('icon-notification-filled',{attrs:{"width":"26","height":"26","color":"#8f95e6"}}),(_vm.number > 0)?_c('div',{staticClass:"number"},[_vm._v(" "+_vm._s(_vm.number)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }